import classes from "./SidebarBtn.module.css";

export function SidebarBtn({
  label,
  alt,
  icon,
  activeIcon,
  isActive,
  onClick,
}) {
  return (
    <button
      className={isActive ? classes.activeBtn : classes.btn}
      onClick={onClick}
    >
      <img src={isActive ? activeIcon : icon} alt={alt} />
      {label}
    </button>
  );
}
